import { anonymousClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'

const fetchMembershipSettings = async () => {
    return anonymousClient()
        .get(
            `/api/membership-setting`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not fetch membership settings`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchMembershipSettings,
}